import { addHeaderInterceptor as r } from "./add-header-interceptor-factory.js";
const o = (e) => e.interceptors.request.use(
  r("x-caller", () => window.location.href)
);
export {
  o as default
};
//# sourceMappingURL=caller-interceptor.js.map
